//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../../components/inputs/FormInput';
import FormSelectInput from './../../../components/inputs/FormSelectInput';
import { categoriaDocumentoService } from './../../../_services/categoriaDocumento.service.js';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class TriagemListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Nome do grupo"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            style={'col-12 col-sm-4 offset-sm-1'}
            value={entity.nome}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
